module.exports = __webpack_public_path__ + "img/bird-ship.4f55079b.jpg";